<ion-list *ngIf="client" class="ion-margin-top" lines="none">
  <ion-item *ngIf="!showClientContactDetails && !showClientLocationData">
    <ion-note class="ion-margin-left">No client details to display</ion-note>
    <!-- <ion-note class="ion-margin-left">No client details to display</ion-note> -->
  </ion-item>
  <ion-item
    class="ion-text-wrap"
    *ngIf="
      client.getEmail() !== '' &&
      client.getEmail() !== null &&
      client.getEmail() !== undefined
    "
  >
    <ion-icon name="mail" slot="start"></ion-icon>
    <a href="mailto:{{ client.getEmail() }}">{{ client.getEmail() }}</a>
  </ion-item>
  <ion-item
    *ngIf="
      (client.getPhone1() !== '' &&
        client.getPhone1() !== null &&
        client.getPhone1() !== undefined) ||
      (client.getPhone2() !== '' &&
        client.getPhone2() !== null &&
        client.getPhone2() !== undefined)
    "
  >
    <ion-icon name="call" slot="start"></ion-icon>
    <ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col
          *ngIf="
            client.getPhone1() !== '' &&
            client.getPhone1() !== null &&
            client.getPhone1() !== undefined
          "
        >
          <ion-label>Home phone</ion-label>
          <h4 class="ion-no-margin">
            <a href="tel:{{ client.getPhone1() }}"
              >{{ client.getPhone1() }}&nbsp;</a
            >
          </h4>
        </ion-col>
      </ion-row>
      <ion-row style="margin-top: 3px">
        <ion-col
          *ngIf="
            client.getPhone2() !== '' &&
            client.getPhone2() !== null &&
            client.getPhone2() !== undefined
          "
        >
          <ion-label>Mobile phone</ion-label>
          <h4 class="ion-no-margin">
            <a href="tel:{{ client.getPhone2() }}">{{ client.getPhone2() }} </a>
          </h4>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-item>

  <ion-item
    class="ion-margin-top client-address"
    *ngIf="showClientLocationData"
  >
    <ion-icon name="home" slot="start"></ion-icon>
    <ion-grid class="ion-no-padding">
      <ion-row
        *ngIf="
          client.getAddress1() !== '' &&
          client.getAddress1() !== null &&
          client.getAddress1() !== undefined
        "
      >
        <ion-col>
          {{ client.getAddress1() }}
        </ion-col>
      </ion-row>
      <ion-row
        *ngIf="
          client.getAddress2() !== '' &&
          client.getAddress2() !== null &&
          client.getAddress1() !== undefined
        "
      >
        <ion-col>
          {{ client.getAddress2() }}
        </ion-col>
      </ion-row>
      <ion-row
        *ngIf="
          client.getCity() !== '' &&
          client.getCity() !== null &&
          client.getCity() !== undefined
        "
      >
        <ion-col> {{ client.getCity() }}, </ion-col>
      </ion-row>
      <ion-row
        *ngIf="
          client.getProvince() !== '' &&
          client.getProvince() !== null &&
          client.getProvince() !== undefined
        "
      >
        <ion-col>
          {{ client.getProvince() }}
        </ion-col>
      </ion-row>
      <ion-row
        *ngIf="
          client.getProvince() !== '' &&
          client.getProvince() !== null &&
          client.getProvince() !== undefined
        "
      >
        <ion-col
          *ngIf="
            client.getCountry() !== null && client.getCountry() !== undefined
          "
        >
          {{ client.getCountry().getCountryName() }}
        </ion-col>
      </ion-row>
      <ion-row
        *ngIf="
          client.getPostal() !== '' &&
          client.getPostal() !== null &&
          client.getPostal() !== undefined
        "
      >
        <ion-col>
          {{ client.getPostal() }}
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-item>

  <ion-item
    *ngIf="
      client.getNotes() !== '' &&
      client.getNotes() !== null &&
      client.getNotes() !== undefined &&
      !hidePermanentNote
    "
  >
    <ion-icon name="document" slot="start"></ion-icon>
    <p>
      {{ client.getNotes() }}
    </p>
  </ion-item>
  <ion-item *ngIf="cardOnFile && !loadingCardData">
    <ion-icon slot="start" name="card"></ion-icon
    ><span class="capitalize">{{ cardInfo.brand }}</span> &nbsp;ending in
    {{ cardInfo.last4 }} exp {{ cardInfo.exp_month }}/{{ cardInfo.exp_year
    }}<ion-button
      fill="clear"
      slot="end"
      (click)="addCardOnFile()"
      tappable
      [disabled]="isReadOnly"
      ><ion-icon name="pencil"></ion-icon></ion-button
    ><ion-button
      fill="clear"
      slot="end"
      (click)="removeCardOnFile()"
      tappable
      [disabled]="isReadOnly"
      ><ion-icon name="close" icon-only></ion-icon
    ></ion-button>
  </ion-item>
</ion-list>

<ion-button
  fill="outline"
  class="ion-margin"
  *ngIf="!cardOnFile && !loadingCardData && hasStripeAccount"
  (click)="addCardOnFile()"
  tappable
  [disabled]="isReadOnly"
>
  Add card on file
</ion-button>
